export const lightGeneralColors = {
  primary: {
    // main: "#284CB1",
    main: "#2F66F4",
    light: "#6881C8",
  },
  secondary: {
    main: "#3E3E3B7D",
    light: "#B8B8B8",
    contrastText: "#BDBDBD",
    dark: "#3E3873",
  },

  success: {
    main: "#27AE60",
    light: "#6FCF971A",
  },
  error: {
    main: "#f44336",
  },
  warning: {
    main: "#ff9800",
  },
  info: {
    main: "#2196f3",
  },
  violet: {},
  salmon: {},
  lightBlue: {
    light: "#F0F4FF",
    main: "#D4DBEF",
  },

  ascent: {
    main: "#F99D16",
    light: "#FEEACE",
  },
  neutral: {
    main: "#000E2C",
    light: "#64748B",
    contrastText: "#9199A8",
  },
  customOne: {
    light: "#F5F7F9",
    main: "#818181",
  },
  text: {
    primary: "#7D8590",
    secondary: "#0E0E2C",
  },
};

export const darkGeneralColors = {
  primary: {
    main: "#6E25CC",
    light: "#6E25CC1A",
  },
  secondary: {
    main: "#6E25CC1A",
  },
  text: {
    primary: "#7D8590",
    disabled: "#7D859050",
  },
};
